import React from 'react'

import {
  Backdrop,
  Modal,
  Card,
  CardHeader,
  CardContent,
  Divider,
  IconButton,
} from '@material-ui/core'

import useStyles from './styles'
import { FaTimes } from 'react-icons/fa'

const ModalComponent = ({ children, title, open, onClose = () => {} }) => {
  const {
    root,
    paper,
    card,
    cardContent,
    action,
    header,
    titleClass,
    closeButton,
  } = useStyles()

  return (
    <Modal
      aria-labelledby="modal"
      aria-describedby="modal"
      className={root}
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <div className={paper}>
        <Card className={card}>
          <CardHeader
            classes={{ action: action, root: header, title: titleClass }}
            title={title}
            action={
              <IconButton
                className={closeButton}
                aria-label="close"
                onClick={onClose}
              >
                <FaTimes />
              </IconButton>
            }
          />
          <Divider />
          <CardContent className={cardContent}>{children}</CardContent>
        </Card>
      </div>
    </Modal>
  )
}

export default ModalComponent
